import { http_client } from "@/plugins/http_client";

const url = "/api/v1/catalogos/cod-actividad";
const getActividadesEconomicas = async (params = {}) =>
  await http_client(url, params, "get");

export default {
  getActividadesEconomicas,
};
